import styles from "./Document.module.css";
import Modal from "../../Utils/Modal";
import { Icon } from 'react-icons-kit';
import { slash } from 'react-icons-kit/feather/slash';
import cogoToast from "cogo-toast-react-17-fix";
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { BASE_URL, GET_MASTER_DOCUMENTS, GET_PDF, GET_ALL_DOCS_ISSUER_ID, REGISTER_DOCUMENT, REMOVE_DOCUMENT, UPDATE_DOCUMENT_STATUS, PREVIEW_DOCUMENT, USER_TOKEN, NIDLIST } from "../../Utils/constant";
import { MESSAGE, STATUS } from "../../Utils/Strings";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { IssuerDate, Debounce, Delay, _ToNormal, isInternalUser } from "../../Utils/helper";
import API from '../../ApiConfig'
import Loader from "../../components/Loader";
import useRefreshToken from "../../Hooks/usegenerateToken";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import ReactPortalModal from "../../components/ReactPortalModal";

const Documents = ({ id }) => {
  let access_token = useRefreshToken(BASE_URL + USER_TOKEN)
  const navigate = useNavigate()
  let { user_type } = useParams();


  const [Popup, setPopup] = useState(false);
  const [previewDocId, setpreviewDocId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pdfLink, setPdfLink] = useState("")
  const [docPopup, setDocPopup] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [pdfload, setpdfload] = useState(false)
  const [loadingText, setLoadingText] = useState('Genrating PDF... Please Wait')


  const updateDocPopup = (bool) => {
    setDocPopup(bool)
    setpreviewDocId(null)
    setLoadingText('Genrating PDF... Please Wait')
    setPdfLink(null)
  }

  const updateModal = (bool) => {
    setPopup(bool)
  }

  const [DocList, setDocList] = useState([])
  const [SelectDocs, setSelectDocs] = useState([])
  const [FilteredDocs, setFilteredDocs] = useState([1, 2])

  const get_documents = async () => {
    setLoading(true)
    await Delay()
    API.get(GET_ALL_DOCS_ISSUER_ID + id)
      .then(data => {
        let res = data.data
        setSelectDocs(res.data)
        setFilteredDocs(res.data)
      })
      .catch(err => {
        cogoToast.error(err.message)
      }).finally(() => {
        setLoading(false)
      }
      )
  }

  const handleSearchFilter = Debounce((value) => {
    setFilteredDocs(SelectDocs.filter(item => item.doc_name.toLowerCase().includes(value.toLowerCase())))
  }, 300)

  // const handleSearchFilter = (value) => {
  //   let result = SelectDocs.filter(item => item.doc_name.includes(value))
  //   setFilteredDocs(result)
  // }


  useEffect(() => {
    API.get(GET_MASTER_DOCUMENTS)
      .then(data => {
        let res = data.data
        setDocList(res.data)
      })
      .catch(err => {
        cogoToast.error(err.message)
      })
    get_documents()
  }, [])

  useEffect(() => {
    if (!loading) {
      setInitialLoad(true);
      const timer = setTimeout(() => setInitialLoad(false), 500);
      return () => clearTimeout(timer);
    }
  }, [loading]);
  const DisplayDocName = React.memo(({ document, checkedItems, AddDoc }) => {
    if (NIDLIST.includes(document.id) && id != 1) {
      return null;
    }

    const isChecked = checkedItems.includes(document.name);

    return (
      <div className={styles.elements} onClick={() => AddDoc(document.name)}>
        <div className={styles.inputBtn}>
          <input
            className={styles.inputCheck}
            type="checkbox"
            checked={isChecked}
            readOnly
          />
          <img src={document.icon} />
          <label style={{ alignSelf: 'center' }}>{document.name}</label>
        </div>
      </div>
    );
  });

  const AddDocument = () => {
    const [checkedItems, setCheckedItems] = useState([]);

    const AddDoc = useCallback((name) => {
      setCheckedItems((prev) =>
        prev.includes(name)
          ? prev.filter((item) => item !== name)
          : [...prev, name]
      );
    }, []);

    const submitForm = (e) => {
      setLoading(true)
      e.preventDefault();
      updateModal(false)
      let temparr = DocList.filter(item => checkedItems.includes(item.name))
      let formData = []
      for (let i in temparr) {
        formData.push({ issuer_id: id, doc_name: temparr[i].name })
      }
      API.post(REGISTER_DOCUMENT, formData)
        .then(data => {
          const res = data.data
          let temparr = res.data
          var notpresent = checkedItems.filter(element => !temparr.some(obj => obj.master_doc_name === element));
          var present = checkedItems.filter(element => temparr.some(obj => obj.master_doc_name === element));
          if (notpresent.length > 0)
            cogoToast.error("could not add " + notpresent + " before completing previous version", { position: 'top-right' })
          if (present.length > 0)
            cogoToast.success("Added " + present, { position: 'top-right' })
          setSelectDocs(temp => [...temp, ...res.data])
          setFilteredDocs(temp => [...temp, ...res.data])
          setCheckedItems([])
          setLoading(false)
        });
    }

    const memoizedDocList = useMemo(() => {
      return DocList.map((document) => (
        <DisplayDocName
          key={document.id}
          document={document}
          checkedItems={checkedItems}
          AddDoc={AddDoc}
        />
      ));
    }, [checkedItems, AddDoc]);

    return (
      <form>
        <div className={styles.Container}>
          <span style={{ margin: '1rem', color: 'gray', fontWeight: '700' }}>
            You Can Choose Multiple Documents
          </span>
          <div className={styles.List}>{memoizedDocList}</div>
          {/* <div className={styles.Continuebtn}> */}
          {/* <div className={styles.btn}> */}
          <button type="submit" onClick={submitForm} className="btn btn-primary">
            Continue
          </button>
          {/* </div> */}
          {/* </div> */}
        </div>
      </form>
    );
  };

  const removeDoc = (id) => {
    fetch(BASE_URL + REMOVE_DOCUMENT + id + "/", {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + access_token
      }
    })
      .then(response => response.json())
      .then(data => {
        let temparr = SelectDocs.filter(Doc => Doc.id !== id)
        setSelectDocs(temparr)
        setFilteredDocs(FilteredDocs.filter(Doc => Doc.id !== id))
      });
  }

  const setPDFpreviewID = (id) => {
    cogoToast.info(loadingText)
    setpdfload(true)
    setTimeout(() => {
      setpreviewDocId(id)
      setpdfload(false)
    }, 2000);
    let url = PREVIEW_DOCUMENT + id
    if (id > 4) {
      url = GET_PDF + id
    }
    API.get(url)
      .then(response => {
        setPdfLink(response.data.data.pdf)
      })
      .catch(err => {
        setLoadingText('Error in Genrating PDF!')
      })
  }

  const PDFPreview = (doc) => {
    var loading = {
      padding: "1rem",
      height: "10vh",
      width: "-webkit-fill-available",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }

    if (!pdfLink) {
      return (<div style={loading}>
        {loadingText}
      </div>)
    }
    else {
      return (
        <embed
          key={pdfLink}
          id="pdf-viewer"
          src={pdfLink + "#toolbar=0"}
          type="application/pdf"
          style={{width:"1000px", height:"700px"}}
        ></embed>
      )
    }
  }

  const disableDoc = (id) => {
    setLoading(true)
    let temparr = SelectDocs.filter(Doc => Doc.id == id)[0]
    if (temparr.document_state == STATUS.ISSUED) {
      cogoToast.error(MESSAGE.DOCUMENT_ALREADY_ISSUED, { position: 'top-right' })

    }
    else {
      if (temparr.document_state == STATUS.ACTIVE || temparr.document_state == STATUS.INACTIVE) {
        API.put(UPDATE_DOCUMENT_STATUS + id)
          .then(data => {
            get_documents()
          });
      }
      else {
        // cogoToast.error(`Could not activate if Status is ${_ToNormal(temparr.document_state)}`, { position: 'top-right' })
        cogoToast.error(MESSAGE.COULD_NOT_ACTIVATE, { position: 'top-right' })

      }
    }
    setLoading(false)
  }

  const handleFilter = () => {
    alert("Filtered");
  }

  const AddDocumentModal = () => {
    return (
      <div className={styles.profilecardcontainer}>
        <Loader isOpen={loading} />
        <div className={styles.tableHeader1}>
          <h2 className={styles.noDesignCreated}>No Document Added Yet</h2>
          <div className={styles.buttonWrapper}>
            <div className={styles.button1}>
              {/* modal is causing component to reload and unable to add document
             <Modal 
              title="Add Document" 
              button="+ Add Document" 
              buttonType="button" 
              content={<AddDocument/>} 
              Popup={Popup}
              updateModal={updateModal}/> */}
            </div>
          </div>
        </div>
      </div>
    )
  }

  // const SelectedDocument = () => {
  //   if (FilteredDocs.length < 1) {
  //     return (<AddDocumentModal />)
  //   }
  //   return (
  //     <div style={{ overflowX: "Scroll", width: "100%" }}>
  //       <Loader isOpen={loading} />
  //       <table className={styles.table}>
  //         <thead>
  //           <tr>
  //             <th className={styles.th}>MASTER DOCUMENT</th>
  //             <th className={styles.th}>DOCUMENT NAME</th>
  //             <th className={styles.th}>VERSION</th>
  //             <th className={styles.th}>LAST UPDATED ON</th>
  //             <th className={styles.th}>TAGS</th>
  //             <th className={styles.th}>DESIGN</th>
  //             <th className={styles.th}>STATUS</th>
  //             <th className={styles.th}>ACTIONS</th>
  //           </tr>
  //         </thead>
  //         {FilteredDocs.map((i, index) => {
  //           let design = i.design == STATUS.DONE ? styles.done : styles.pending
  //           let tags = i.tags == STATUS.DONE ? styles.done : styles.pending
  //           let status = i.status == STATUS.DONE ? styles.done : styles.inactive
  //           return (
  //             <tbody key={i.id}>
  //               <tr className={`${styles.tr} ${initialLoad ? styles.fadeIn : ''}`}
  //                 style={loading ? null : { animationDelay: `${index * 0.1}s` }}
  //               >
  //                 <td className={styles.td}>
  //                   <div>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.master_doc_name}</div>
  //                 </td>
  //                 <td className={styles.td}>
  //                   <div>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.doc_name}</div>
  //                 </td>
  //                 <td className={styles.td}>
  //                   <div className={styles.time}>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.version}</div>
  //                 </td>
  //                 <td className={styles.td}>
  //                   <div className={styles.time}>
  //                     {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : <IssuerDate dateString={i.updated_at} />}
  //                   </div>
  //                 </td>
  //                 <td className={styles.td}>
  //                   {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
  //                     (i.tags ? <div className={tags}>{i.tags}</div> : <div className={tags}>{STATUS.PENDING}</div>)}
  //                 </td>
  //                 <td className={styles.td}>
  //                   {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
  //                     (i.design ? <div className={design}>{i.design}</div> : <div className={design}>{STATUS.PENDING}</div>)}
  //                 </td>
  //                 <td className={styles.td}>
  //                   {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
  //                     // (i.status == STATUS.DONE ? <div className={status}>{STATUS.ACTIVATED}</div>:  <div className={status}>{i.status || STATUS.DEACTIVATED}</div>)}
  //                     <div className={status}>{_ToNormal(i.document_state)}</div>}
  //                 </td>
  //                 <td className={styles.td}>
  //                   {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
  //                     <div className={styles.buttonBase}>
  //                       {
  //                         (i.status == STATUS.DONE || i.status == STATUS.ISSUED) ?
  //                           // (i.status == STATUS.PENDING || i.status == STATUS.DONE) ?

  //                           <button className={styles.button + " " + styles.preview} title="Preview" onClick={() => setpreviewDocId(i.id)}>
  //                             <img src='/eyeoutline.svg' />
  //                           </button>
  //                           :
  //                           <button className={styles.button + " " + styles.disabled} title="Preview"><img src='/eyeoutline.svg' /></button>
  //                       }
  //                       <Modal title={i.doc_name + " preview"} isOpen={(i.id === previewDocId)} onClose={updateDocPopup}>
  //                         <PDFPreview doc={i} />
  //                       </Modal>
  //                       {(i.editable && i.status != STATUS.ISSUED) ?
  //                         <button className={styles.button + " " + styles.edit} onClick={() => navigate("/create/" + i.id + "/Mapping")} title="Edit"><img src='/editoutline.svg' className={styles.icon} /></button> :
  //                         <button className={styles.button + " " + styles.disabled} title="Edit" ><img src='/editoutline.svg' /></button>
  //                       }
  //                       {i.status == STATUS.DONE ?
  //                         <button className={styles.button + " " + styles.remove} onClick={() => disableDoc(i.id)} title="Revoke"><Icon icon={slash} /></button> :
  //                         <button className={styles.button} onClick={() => disableDoc(i.id)} title="Revoke"><Icon icon={slash} /></button>
  //                       }
  //                       {/* <button className={styles.button} onClick={()=>removeDoc(i.id)}><img src='/trashoutline.svg' className={styles.icon}/></button> */}
  //                     </div>
  //                   }
  //                 </td>
  //               </tr>
  //             </tbody>
  //           )
  //         })}
  //       </table>
  //     </div>
  //   )
  // }


  const SelectedDocument = () => {
    if (FilteredDocs.length < 1) {
      return (<AddDocumentModal />)
    }
    const location = useLocation();
    const path = location.pathname;

    return (
      <div className={styles.tableWrap}>
        <Loader isOpen={loading || pdfload} />
        <table className={styles.docTable}>
          <thead>
            <tr>
              <th className={styles.th}>MASTER DOCUMENT</th>
              <th className={styles.th}>DOCUMENT NAME</th>
              <th className={styles.th}>VERSION</th>
              <th className={styles.th}>LAST UPDATED ON</th>
              <th className={styles.th}>TAGS</th>
              <th className={styles.th}>DESIGN</th>
              <th className={styles.th}>STATUS</th>
              <th className={styles.th}>ACTIONS</th>
            </tr>
          </thead>
          {FilteredDocs.map((i, index) => {
            let design = i.document_state != STATUS.TAG_MAPPING && i.document_state != STATUS.DOCUMENT_CREATED ? styles.done : styles.pending
            let tags = i.document_state != STATUS.DOCUMENT_CREATED ? styles.done : styles.pending
            let status = i.document_state == STATUS.ACTIVE ? styles.done : i.document_state == STATUS.ISSUED || i.document_state == STATUS.INACTIVE ? styles.inactive : styles.pending
            return (
              <tbody key={i.id}>
                <tr className={`${styles.tr} ${initialLoad ? styles.fadeIn : ''}`}
                  style={loading ? null : { animationDelay: `${index * 0.1}s` }}
                >
                  <td className={styles.td}>
                    <div>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.master_doc_name}</div>
                  </td>
                  <td className={styles.td}>
                    <div>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.doc_name}</div>
                  </td>
                  <td className={styles.td}>
                    <div className={styles.time}>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.version}</div>
                  </td>
                  <td className={styles.td}>
                    <div className={styles.time}>
                      {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : <IssuerDate dateString={i.updated_at} />}
                    </div>
                  </td>
                  <td className={styles.td}>
                    {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                      (tags == styles.done ? <div className={tags}>{STATUS.DONE}</div> : <div className={tags}>{STATUS.PENDING}</div>)}
                  </td>
                  <td className={styles.td}>
                    {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                      (design == styles.done ? <div className={design}>{STATUS.DONE}</div> : <div className={design}>{STATUS.PENDING}</div>)}
                  </td>
                  <td className={styles.td}>
                    {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                      // (i.status == STATUS.DONE ? <div className={status}>{STATUS.ACTIVATED}</div>:  <div className={status}>{i.status || STATUS.DEACTIVATED}</div>)}
                      <div className={status}>{_ToNormal(i.document_state)}</div>}
                  </td>
                  <td className={styles.td}>
                    {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                      <div className={styles.buttonBase}>
                        {
                          // (i.status == STATUS.DONE || i.status == STATUS.ISSUED) ?
                          // (i.status == STATUS.PENDING || i.status == STATUS.DONE) ?
                          (i.document_state != STATUS.DOCUMENT_CREATED && i.document_state != STATUS.TAG_MAPPING) ?

                            <button id="pdf-preview" className={[styles.button, styles.preview].join(" ")} title="Preview" onClick={() => setPDFpreviewID(i.id)}>
                              <img src='/eyeoutline.svg' />
                            </button>
                            :
                            <button className={styles.button + " "} title="Preview" style={{cursor:"not-allowed"}}><img src='/eyeoutline.svg' /></button>
                        }
                        <ReactPortalModal title={i.doc_name + " preview"} isOpen={(i.id === previewDocId)} onClose={updateDocPopup} blockOutsideClick={true} width={"100px"}>
                          <PDFPreview doc={i} />
                        </ReactPortalModal>
                        {(i.editable && i.document_state != STATUS.ISSUED && i.document_state !== STATUS.INACTIVE) ?
                          <button className={styles.button + " " + styles.edit} onClick={() => navigate("/create/" + i.id + "/Mapping")} title="Edit"><img src='/editoutline.svg' className={styles.icon} /></button> :
                          <button className={styles.button + " "} title="Edit"  style={{cursor:"not-allowed"}}><img src='/editoutline.svg'  /></button>
                        }
                        {i.document_state == STATUS.ACTIVE ?
                          <button className={styles.button + " " + styles.remove} onClick={() => disableDoc(i.id)} title={STATUS.DEACTIVATED}><Icon icon={slash} /></button> :
                          <button className={styles.button} onClick={() => disableDoc(i.id)} title={i.document_state == STATUS.ISSUED ? STATUS.ISSUED : STATUS.ACTIVATED}><Icon icon={slash} /></button>
                        }
                        {/* <button className={styles.button} onClick={()=>removeDoc(i.id)}><img src='/trashoutline.svg' className={styles.icon}/></button> */}
                        {path.includes("/company/") ? null :
                          i.document_state == STATUS.ACTIVE || i.document_state == STATUS.ISSUED ?

                            <Link to="/dashboard/credentials/issue-credentials" state={{ data: i, isNew: false, step: 3 }} className={`btn ${styles.activate}`} style={{ textDecoration: 'none' }}>Issue</Link> :
                            <Link to='#' state={{ documentId: i.id }} className={`btn ${styles.activate}`} style={{ textDecoration: 'none', backgroundColor: "lightgray", cursor: "not-allowed" }}>Issue</Link>
                        }
                      </div>
                    }
                  </td>
                </tr>
              </tbody>
            )
          })}
        </table>
      </div>
    )
  }

  let isInternal = isInternalUser()
  return (
    <div className={styles.companyProfile}>
      <section className={styles.companyLogoInstance}>
        <div className={styles.inputFieldInstance}>
          <div className={styles.h1}>
            <h2 className={styles.h}>Templates</h2>
            <div className={styles.buttonWrapper}>
              <button onClick={() => navigate(isInternal ? `/company/${user_type}/${id}/newDocument` : '/dashboard/TemplateType', {state:{from:"Issuer"}})} className="btn btn-primary" style={{ fontSize: "15px" }}>
                <div>+ Create Template</div>
              </button>
            </div>
          </div>
          <Modal title="Add Document" isOpen={Popup} onClose={updateModal} blockOutsideClick={true}>
            <AddDocument />
          </Modal>
          <div className={styles.tableHeader} style={{
            alignSelf: "center", flexWrap: "wrap",
            width: "100%",
            margin: "1rem",
            position: "relative",
            top: "1rem",
            left: "0.15rem"
          }}>
            <div className={styles.inputField}>
              <div className={styles.input}>
                <div className={styles.content}>
                  <img className={styles.searchOutlineIcon} alt="" src="/searchoutline.svg" />
                  <div className={styles.inputText}><input type="text" placeholder="Search by keyword" onChange={e => handleSearchFilter(e.target.value)} /></div>
                </div>
              </div>
            </div>
            {/* <div className={styles.buttons} style={{minWidth:"500px"}} onClick={handleFilter}>
        <div className={styles.button}>
          <img className={styles.filterIcon} alt="" src="/filter.svg" />
          <div className={styles.bellicon} style={{display:"flex"}}>
            Filter
          </div>
          <img className={styles.chevronDownIcon} alt="" src="/chevrondown.svg"/>
        </div>
      </div> */}
          </div>
          {/* {SelectDocs.length>0?<SelectedDocument/>:<AddDocumentModal/>} */}
          <SelectedDocument />
        </div>
      </section>
    </div>
  );
};

export default Documents;